export const AMC_CATEGORY_LIST_CATEGORY_DATA = "AMC_CATEGORY_LIST_CATEGORY_DATA";
export const AMC_CATEGORY_LIST_CATEGORY_ERROR = "AMC_CATEGORY_LIST_CATEGORY_ERROR";
export const AMC_CATEGORY_LIST_CATEGORY_HIDE_ERROR = "AMC_CATEGORY_LIST_CATEGORY_HIDE_ERROR";
export const AMC_CATEGORY_LIST_CATEGORY_START_LOADER = "AMC_CATEGORY_LIST_CATEGORY_START_LOADER";
export const AMC_CATEGORY_LIST_CATEGORY_STOP_LOADER = "AMC_CATEGORY_LIST_CATEGORY_STOP_LOADER";
